import { AxiosInstance, AxiosResponse } from 'axios';
import type { CustomField, CustomValue } from 'jsforce/lib/api/metadata';

import { SObject, MetadataDiff } from '@/types';

export interface CompareRecord {
  id: string;
  sobject: SObject;
  fieldName: string;
  fullName: string;
  sourceField: CustomField;
  targetField: CustomField;
  sourceValueSetValues: CustomValue[];
  targetValueSetValues: CustomValue[];
}
export interface RestrictedFieldRecord {
  sobject: SObject;
  fieldName: string;
}

export interface GetFieldLevelSecurityResponse {
  source: RestrictedFieldRecord[];
  target: RestrictedFieldRecord[];
}

class MetadataService {
  private readonly client: AxiosInstance;

  constructor(client: AxiosInstance) {
    this.client = client;
  }

  getDiff(): Promise<MetadataDiff[]> {
    return this.client
      .get<MetadataDiff[]>('/apis/metadata/v1/diff')
      .then((res) => res.data);
  }

  comparePickListValues(): Promise<CompareRecord[]> {
    return this.client
      .get<CompareRecord[]>('/apis/metadata/v1/compare')
      .then(({ data }) => data);
  }

  getFieldLevelSecurity(): Promise<GetFieldLevelSecurityResponse> {
    return this.client
      .get<GetFieldLevelSecurityResponse>('/apis/metadata/v1/security')
      .then((res) => res.data);
  }

  deployPickListValues(
    records: CompareRecord[]
  ): Promise<AxiosResponse<unknown>> {
    return this.client.post('/apis/metadata/v1/deploy', { records });
  }
}

export default MetadataService;
